import React from "react";
import { Box, Typography, Grid, List, ListItem, Button, Divider  } from "@mui/material";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";

function Footer() {
    return (
        <Box
        sx={{
          backgroundColor: "rgb(240, 240, 240)",
          textAlign: "center",
          padding: 2,
          mt: 4,
        }}
      >
        <Typography variant="body2" sx={{ color: "#666" }}>
          <a
            href="https://portend.ai/terms-and-conditions/"
            style={{
              color: "rgb(0, 145, 70)",
              textDecoration: "none",
              marginRight: "10px",
            }}
          >
            Terms of Service
          </a>
          |
          <a
            href="https://portend.ai/privacy-policy/"
            style={{
              color: "rgb(0, 145, 70)",
              textDecoration: "none",
              marginLeft: "10px",
            }}
          >
            Privacy Policy
          </a>
        </Typography>
      </Box>
    )
};

export default Footer;